import styled from '@emotion/styled'

export const THead = styled.thead(() => ({}))
